import React from 'react';

// fontawesome set up
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// style and logo imports
import './style.css';
import { faFacebook } from '@fortawesome/free-brands-svg-icons';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import clayLogo from '../../assets/images/clays-logo.webp';
import ricslogo from '../../assets/images/rics-logo.png';
function Footer() {
    return (
        <footer>
            {/* Ric's Bread Name Logo */}
            <div className='footer-logo'>
                <img src={ricslogo} alt="Ric's Bread Logo" />
            </div>

            {/* links to social media and contact */}
            <div className='social-links'>
                <a href="https://www.facebook.com/p/Rics-Bread-100063749435800/" alt='Link to Rics Bread Facebook' rel='noreferrer' target="_blank" style={{ fontSize: 0 }}>
                    Facebook
                    <FontAwesomeIcon alt='Rics Bread Facebook' className="footer-icon" icon={faFacebook} />
                </a>

                <a alt='Link to Rics Bread Instagram' href="https://www.instagram.com/ricsbreadlancaster/" rel='noreferrer' target="_blank" style={{ fontSize: 0 }}>
                    Instagram
                    <FontAwesomeIcon alt='Beverage Express Instagram' className="footer-icon" icon={faInstagram} />
                </a>


                <a href="mailto: ricsbreadkc@gmail.com" rel='noreferrer' target="_blank" style={{ fontSize: 0 }}>
                    Email
                    <FontAwesomeIcon className="footer-icon" icon={faPaperPlane} />
                </a>
            </div>

            {/* Web developer information */}
            <div className='site-creator'>
                <div className='site-creator-logo-div'>
                    <img
                        className='site-creator-logo'
                        src={clayLogo}
                        alt="Clay's Creative Solutions Logo"
                    />
                    <p className='copyright'>
                        ©2025 Clay's Creative Solutions
                        <br />Small business support for small business
                    </p>
                </div>

                <div className='site-creator-contact'>
                    <a className='creator-site link' rel='noreferrer' href='https://www.clayscreativesolutions.com' target='_blank'>www.clayscreativesolutions.com</a>
                    <a className='creator-email link' rel='noreferrer' href='mailto: clayscreativesolutions@gmail.com' target='_blank'>clayscreativesolutions@gmail.com</a>
                </div>

            </div>

        </footer>
    );
};

export default Footer;